import Icon from '../components/Icon.vue'

Icon.register({
  'flag-usa': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M32 0C14.3 0 0 14.3 0 32V496C0 504.8 7.2 512 16 512H48C56.8 512 64 504.8 64 496V32C64 14.3 49.7 0 32 0zM299.9 303.6C242.7 288.5 188.2 274.8 96 314.7V384C281.7 291.8 317.7 437.3 493.5 360.9 504.9 355.9 512 344.4 512 332.1V296.1C468.4 313.4 431.8 320.2 399.9 320.2 362.5 320.1 331 311.8 299.9 303.6zM299.9 207.6C242.7 192.5 188.2 178.8 96 218.7V280.2C190.8 242.6 250.6 257.5 308.1 272.6 365.3 287.7 419.8 301.4 512 261.5V200C468.4 217.3 431.8 224.1 399.9 224.1 362.5 224.1 331 215.8 299.9 207.6zM309.4 81.7C361.2 97.3 406.8 110.7 512 61.6V30.8C512 5.7 485.2-7.3 462.6 4.2 291.3 91.5 305.4-62.2 96 32.4V184.3C190.8 146.8 250.6 161.6 308.1 176.7 365.3 191.7 419.8 205.4 512 165.6V96.7C458.4 120.2 418.7 128.1 385.9 128.1S326.9 120.3 300.2 112.2C296.2 111 292.1 109.8 288.1 108.7V75.5C295.3 77.5 302.4 79.6 309.4 81.7zM160 128.1C151.2 128.1 144 121 144 112.1 144 103.3 151.2 96.1 160 96.1S176 103.2 176 112.1 168.8 128.1 160 128.1zM160 72.3C151.2 72.3 144 65.2 144 56.3 144 47.5 151.2 40.3 160 40.3S176 47.4 176 56.3C176 65.1 168.8 72.3 160 72.3zM224 120.2C215.2 120.2 208 113.1 208 104.2 208 95.4 215.2 88.2 224 88.2S240 95.3 240 104.2C240 113 232.8 120.2 224 120.2zM224 64.3C215.2 64.3 208 57.2 208 48.3 208 39.5 215.2 32.3 224 32.3S240 39.4 240 48.3C240 57.1 232.8 64.3 224 64.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/flag-usa.js
// module id = Gb3c
// module chunks = 144